import { z } from 'zod';
export const UpdateUserDriverLicencesSchema = z.object({
    id: z.number(),
    name: z.string().min(1).max(5)
});
//# sourceMappingURL=updateUserDriverLicencesSchema.js.map